import {
  MealProps,
  MealActionTypes,
  GET_MEALS,
  SET_MEALS,
  SET_LAST_MEAL,
  GET_MORE_MEALS,
} from './types';

const initialState: MealProps = {
  meals: [],
  lastMealField: {},
};

export const mealReducers = (state = initialState, action: MealActionTypes) => {
  const { type, meals, lastMealField } = action;
  switch (type) {
    case GET_MEALS:
      return state;
    case SET_MEALS:
      return { ...state, meals: meals };
    case GET_MORE_MEALS:
      return state;
    case SET_LAST_MEAL:
      return { ...state, lastMealField: lastMealField };
    default:
      return state;
  }
};
